import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import { PdInput } from "./PdInput.js";
import { html } from "lit";
import { property } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
//#region src/pd-input/PdComboboxInput.ts
/**
* @license
* Copyright (c) 2021 PD Progressive Development UG. All rights reserved.
*
* Internal combobox input component extending PdInput with ARIA combobox attributes.
* Used by PdSuggestionBox for accessible autocomplete functionality.
*/
/**
* Internal input component with combobox ARIA support.
* Extends PdInput to add role="combobox" and related ARIA attributes.
*
* @internal Not exported - for use by PdSuggestionBox only.
*/
var PdComboboxInput = class extends PdInput {
	constructor(..._args) {
		super(..._args);
		this.expanded = false;
	}
	_renderInputField(inputId, errorId) {
		return html`
      <input
        id="${inputId}"
        name="${this.name || this.valueName || this.autoCompleteName}"
        autocomplete="${this.autoCompleteName ?? "off"}"
        class="input-style ${this.gradient ? "gradient" : ""}"
        type="${this.secret ? "password" : "text"}"
        placeholder="${this.placeHolder}"
        .value="${this._value}"
        minlength="${this.minlength ?? ""}"
        maxlength="${this.maxlength ?? ""}"
        ?readonly="${this.readonly}"
        ?disabled="${this.disabled}"
        role="combobox"
        aria-expanded="${this.expanded ? "true" : "false"}"
        aria-controls="${ifDefined(this.ariaControls)}"
        aria-autocomplete="${ifDefined(this.ariaAutocomplete)}"
        aria-activedescendant="${ifDefined(this.ariaActivedescendant)}"
        aria-invalid="${this._invalid}"
        aria-describedby="${this._errorMsg ? errorId : ""}"
        @keyup="${this._onKeyUp}"
        @blur="${this._onBlur}"
        @focus="${this._onFocus}"
      />
    `;
	}
};
__decorate([property({ type: String })], PdComboboxInput.prototype, "ariaControls", void 0);
__decorate([property({ type: String })], PdComboboxInput.prototype, "ariaAutocomplete", void 0);
__decorate([property({ type: String })], PdComboboxInput.prototype, "ariaActivedescendant", void 0);
__decorate([property({ type: Boolean })], PdComboboxInput.prototype, "expanded", void 0);
var tag = "pd-combobox-input";
if (!customElements.get(tag)) customElements.define(tag, PdComboboxInput);
//#endregion
export { PdComboboxInput };
